var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stamp-base" }, [
    _c("div", { staticClass: "circular-stamp", style: _vm.stampStyle }, [
      _c("span", { staticClass: "stamp-text", style: _vm.textStyle }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }